export default IconExternalLinkOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-external-link-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
  <path d="M10 14l2 -2m2.007 -2.007l6 -6" />
  <path d="M15 4h5v5" />
  <path d="M3 3l18 18" />
</svg>`;